<div fxLayout="column">
    <mat-expansion-panel fxFlex="1 1 auto" fxLayout="column" [expanded]="isTopExpanded">
        <mat-expansion-panel-header>
            <mat-panel-title>Adhoc Queries</mat-panel-title>
        </mat-expansion-panel-header>
        <div fxFlex="1 1 auto" fxLayout="row" fxLayoutGap="3px">
            <button fxFlex="0 0 auto" pButton type="button" (click)="refreshState()" icon="pi pi-refresh"
                label="Refresh"></button>
            <!-- <button [disabled]="!this.selectedQuery" fxFlex="0 0 auto" pButton type="button" icon="pi pi-cloud-download"
            (click)="downloadSelected()" label="Download Selected"></button> -->
            <button [disabled]="!queryStateResult" fxFlex="0 0 auto" pButton type="button" icon="pi pi-plus-circle"
                (click)="openNewQuery()" label="New Query"></button>
        </div>
        <p-table *ngIf="queries" fxFlex="1 1 auto" class="liquitics-box" [value]="queries" selectionMode="single"
            [scrollable]="true" [rows]="6" scrollHeight="15vh" [(selection)]="selectedQuery"
            [loading]="runningRefresh">
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Usage</th>
                    <th>Status</th>
                    <th>Requester</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-query let-rowIndex="rowIndex">
                <tr [pSelectableRow]="query" [pSelectableRowIndex]="rowIndex">
                    <td style="text-align:center">{{query.name}}</td>
                    <td style="text-align:center">{{query.type}}</td>
                    <td style="text-align:center">{{query.usage}}</td>
                    <td style="text-align:center">{{query.status}}</td>
                    <td style="text-align:center">{{query.requester}}</td>
                </tr>
            </ng-template>
        </p-table>
        <div fxFlex="1 1 auto" fxLayout="row" fxLayoutGap="3px">
            <button [disabled]="!selectedQuery" fxFlex="0 0 auto" pButton type="button" icon="pi pi-chart-bar"
                (click)="showSelected()" label="Show Selected"></button>
        </div>
    </mat-expansion-panel>
    <p-progressBar *ngIf="showInProgress" mode="indeterminate" [style]="{'height': '6px'}" fxFlex="5 5 grow">
    </p-progressBar>
    <div [fxHide]="!chart && !showBreakDownData" fxLayout="column">
        <p-header *ngIf="selectedQuery">
            <h4 class="center">{{selectedQuery.name}}</h4>
        </p-header>
        <div fxLayout="row">
            <div fxFlex="1 1 70%" fxLayout="column" class="chartwrapper liquitics-box">
                <div id="chartdiv" [fxHide]="displayType === 'BREAKDOWN'" class="chartdiv"></div>
                <div *ngIf="showBreakDownData && displayType === 'BREAKDOWN'" fxLayout="row">
                    <app-alm-break-down-ladder-table [ladderTreeNodes]="showBreakDownData.adhocQueryTreeNodes"
                        [ladderColumnNames]="showBreakDownData.ladderColumnNames" [groupingColHeaderWidth]="'60%'"
                        (breakDownNodeSelected)="adhocNodeSelected($event)">
                    </app-alm-break-down-ladder-table>
                </div>
            </div>
            <div fxFlex="1 1 30%" fxLayout="column" class="liquitics-box">
                <p-selectButton fxFlex="0 1 auto" [options]="displayTypeOptions" [(ngModel)]="displayType"
                    (onChange)="displayTypeChanged()"></p-selectButton>
                <h3 class="option-label" *ngIf="displayType !== 'BREAKDOWN' && attributeColumnOptions">Category</h3>
                <p-selectButton fxFlex="0 1 auto" *ngIf="displayType !== 'BREAKDOWN' && attributeColumnOptions"
                    [options]="attributeColumnOptions" [(ngModel)]="chartPrimaryAttributeColumn"
                    (onChange)="chartOptionsChanged()" class="option-component"></p-selectButton>
                <h3 class="option-label" *ngIf="displayType !== 'BREAKDOWN' && valueColumnOptions">Value</h3>
                <p-selectButton fxFlex="0 1 auto" *ngIf="displayType !== 'BREAKDOWN' && valueColumnOptions"
                    [options]="valueColumnOptions" [(ngModel)]="chartPrimaryValueColumn"
                    (onChange)="chartOptionsChanged()" class="option-component"></p-selectButton>
                <div fxFlex="0 1 auto" fxLayout="column"
                    *ngIf="displayType !== 'BREAKDOWN' && sortByOptions && sortDirectionOptions">
                    <h3 class="option-label" class="option-label">Sort by</h3>
                    <p-selectButton [options]="sortByOptions" [(ngModel)]="selectedSortByOption"
                        (onChange)="chartOptionsChanged()" class="option-component">
                    </p-selectButton>
                    <h3 class="option-label">Sort direction</h3>
                    <p-selectButton [options]="sortDirectionOptions" [(ngModel)]="selectedSortDirectionOption"
                        (onChange)="chartOptionsChanged()" class="option-component">
                    </p-selectButton>
                </div>
                <div *ngIf="pieOptions && displayType === 'PIE'" fxFlex="1 1 auto" fxLayout="column">
                    <h3 class="option-label">Data usage</h3>
                    <p-selectButton fxFlex="1 1 auto" [options]="pieOptions.dataUsageOptions"
                        [(ngModel)]="pieOptions.dataUsage" (onChange)="chartOptionsChanged()" class="option-component">
                    </p-selectButton>
                </div>
                <div *ngIf="displayType === 'BREAKDOWN'">
                    <p-orderList [value]="showBreakDownData.breakDownColumnNames" dragdrop="true">
                        <ng-template let-column pTemplate="item">
                            <div class="p-helper-clearfix">
                                <span>{{columnToDisplay(column)}}</span>
                            </div>
                        </ng-template>
                    </p-orderList>
                    <p-orderList [value]="showBreakDownData.ladderColumnNames" dragdrop="true">
                        <ng-template let-column pTemplate="item">
                            <div class="p-helper-clearfix">
                                <span>{{columnToDisplay(column)}}</span>
                            </div>
                        </ng-template>
                    </p-orderList>
                    <button pButton type="button" (click)="rebuildBreakDown()" icon="pi pi-refresh"
                        label="Update"></button>
                </div>

            </div>
        </div>
    </div>
    <div fxLayout="row" *ngIf="downloadData">
        <p-table #dt class="liquitics-box" [columns]="downloadColumns" [value]="downloadData" [scrollable]="true"
            [rows]="30" scrollHeight="75vh" sortMode="multiple" [resizableColumns]="true" [loading]="loading"
            [exportFilename]="selectedQuery.name + '.csv'">
            <ng-template pTemplate="caption">
                <div style="text-align: right">
                    <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                    <input type="text" pInputText size="50" placeholder="Global Filter"
                        (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
                </div>
                <button [disabled]="!selectedQuery || (!downloadData || downloadData.length === 0)" type="button"
                    fxFlex="0 0 auto" pButton icon="fa fa-file-o" iconPos="left" label="Export All Data"
                    (click)="dt.exportCSV()" style="float:left"></button>
            </ng-template>
            <ng-template pTemplate="colgroup" let-columns>
                <colgroup>
                    <col *ngFor="let col of columns" style="width:150px">
                </colgroup>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                        {{col.header}}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
                <tr>
                    <th *ngFor="let col of columns" [ngSwitch]="col.field">
                        <input pInputText type="text"
                            (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)">
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [pSelectableRow]="rowData">
                    <td *ngFor="let col of columns" style="text-align:center">
                        {{rowData[col.field]}}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>